module.exports = __webpack_public_path__ + "static/media/substractionButtonDisabled.d522a48b.svg";